import { render, staticRenderFns } from "./BusstopMenu.vue?vue&type=template&id=3d098a8e&scoped=true&"
import script from "./BusstopMenu.vue?vue&type=script&lang=js&"
export * from "./BusstopMenu.vue?vue&type=script&lang=js&"
import style0 from "./BusstopMenu.vue?vue&type=style&index=0&id=3d098a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d098a8e",
  null
  
)

export default component.exports